import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Loading from 'app/components/loaders/Loading';

import useApi from 'app/context/useApi';
import { useHistory } from 'react-router-dom';

export default function EmailCampaignsDialog(props) {

    const { open, onSave, onClose, onClosed, data, ids } = props;

    const [ loading, setLoading ] = useState(false);

    const api = useApi();
    let history = useHistory();

    const postNoticeEmails = () => {

        setLoading(true);

        api.get('/admin/accounting/invoice/send/notice')
            .then(() => onSave())
            .catch(() => setLoading(false));
    }

    const routeIdsToEmailService = () => {

        const emails = [];

        data.forEach(item => {
            const i = ids.indexOf(item.id);
            if (i > -1) emails.push(item.email);
        })

        history.push(`/admin/emails/0`, { emails: emails });
    }

    // Exting Functions ----------------------------------------

    const clearState = () => {

    };

    const handleClosed = () => {
        clearState();
        setLoading(false);
        if (onClosed) onClosed();
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="email-notices-dialog-title"
            aria-describedby="email-notices-dialog-description"
            >
            <Loading isLoading={loading}/>
            <DialogTitle id="email-notices-dialog-title">{ids.length === 0 ? 'Send Emails for all Past Due Membership Invoices?' : 'Email selected invoice users?'}</DialogTitle>
            <DialogContent>
                <DialogContentText id="email-notices-dialog-description">
                    {(ids.length === 0) ? (
                        <>By clicking <strong>SEND</strong>, you will send an email for each Past Due Membership Invoice. You can only do this once every 24 hours.</>
                    ) : (
                        <>By clicking <strong>EMAIL</strong>, you will be sent over to the email page and can send an email to the selected invoice users.</>
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} autoFocus>
                    Cancel
                </Button>
                <Button onClick={(ids.length === 0) ? postNoticeEmails : routeIdsToEmailService} color="primary" variant="contained">
                    {ids.length === 0 ? 'Send' : 'Email'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
